import { Component, Input } from '@angular/core';
import { ValidationService } from '../../../core/services/validation.service';

@Component({
  selector: 'app-form-errors',
  standalone:true,
  imports: [],
  templateUrl: './form-errors.component.html',
  styleUrl: './form-errors.component.scss',
})
export class FormErrorsComponent {

  @Input() control!: any;
  emailRegex: any = "";
  passwordRegex: any = "";
  urlRegex: any = "";

  constructor(private validationService: ValidationService) {
    this.emailRegex = this.validationService.emailRegex;
  }
  


}
